export enum SubmissionPermissionSelectionTypeEnum {
  Some = 1,
  All = 2,
  None
}
